import { Divider } from '@mui/material';
import { useAtom } from 'jotai';

import CheckPermissions from '@/components/CheckPermissions';
import LargeCard from '@/components/LargeCard';
import MessageInput from '@/components/MessageInput';
import Messages from '@/components/Messages';
import { PERMISSIONS } from '@/constants/auth.constants';
import { ticketMessagesAtom } from '@/pages/Ticket';

const TicketDetailsConversation = () => {
  const [messages] = useAtom(ticketMessagesAtom);

  return (
    <LargeCard title="Conversation">
      {messages && (
        <>
          <CheckPermissions permissions={[PERMISSIONS.TICKETS_UPDATE]}>
            <MessageInput />
            <Divider sx={{ mt: 4 }} />
          </CheckPermissions>
          <Messages />
        </>
      )}
    </LargeCard>
  );
};

export default TicketDetailsConversation;
